import profile from './profile-pic-settings.svg';
import games from './icon-games.svg';
import stat from './icon-stats.svg';
import autoTest from './icon-auto-test.svg';
import evalIcon from './icon-eval.svg';

export const sidebarIcons = {
    profile,
    games,
    stat,
    autoTest,
    evalIcon
};